import { SortItem } from '@tanium/react-stacked-ribbon-list';

// Since these functions return a static value function. We can ignore the code coverage
/* istanbul ignore next */
export function alwaysTrueOp(): boolean {
  return true;
}

/* istanbul ignore next */
// eslint-disable-next-line @typescript-eslint/no-empty-function
export function noop(): void { }

// Blank values sort last in both directions so a sparse column does not crowd either end.
const isBlank = (value: unknown): boolean => value === undefined || value === null || value === '';

export function sortData<T>(sortState: SortItem[], values: T[]): T[] {
  if (!sortState.length) {
    return [...values];
  }
  const { dataKey, sortDirection } = sortState[0];
  const property = dataKey as keyof T;
  const asc = sortDirection === 'ASC' ? 1 : -1;
  const compareFn = (a: T, b: T): number => {
    const left = a[property];
    const right = b[property];
    if (isBlank(left) && isBlank(right)) {
      return 0;
    }
    if (isBlank(left)) {
      return 1;
    }
    if (isBlank(right)) {
      return -1;
    }
    if (left! > right!) {
      return asc;
    }
    if (left! < right!) {
      return -asc;
    }
    return 0;
  };
  return [...values].sort(compareFn);
}

export function removeEmptyObjectValues(obj: Record<string, any>) {
  const isEmptyValue = (value: unknown) => value === null || value === undefined || value === '';

  const cleanValue = (value: any): any => {
    if (isEmptyValue(value)) {
      return undefined;
    }

    if (Array.isArray(value)) {
      return value.map(cleanValue).filter((item) => item !== undefined);
    }

    if (typeof value === 'object') {
      return Object.fromEntries(
        Object.entries(value as Record<string, any>)
          .map(([key, nestedValue]) => [key, cleanValue(nestedValue)] as [string, any])
          .filter(([_, nestedValue]) => nestedValue !== undefined),
      );
    }

    return value;
  };

  return cleanValue(obj) as Record<string, any>;
}
